import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'

const PRIVATE_MODE_TIERS = new Set([
  STUDIO_ACCESS_TIER.SUBSCRIBED,
  STUDIO_ACCESS_TIER.HAS_CREDITS,
])

function usePrivateModeAccess() {
  const studioAccessTier = useThreeDStudioStore((state) => state.subscription.studioAccessTier)
  return PRIVATE_MODE_TIERS.has(studioAccessTier)
}

export default usePrivateModeAccess
